import { render, staticRenderFns } from "./AddNewStaffSkillPopUp.vue?vue&type=template&id=f4ebbd6e&scoped=true&"
import script from "./AddNewStaffSkillPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewStaffSkillPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewStaffSkillPopUp.vue?vue&type=style&index=0&id=f4ebbd6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ebbd6e",
  null
  
)

export default component.exports